import { createEntityMetadataMap } from '@mri-platform/shared/entity';
import { JobLog, JobLogError } from '../models';

export const entityMetadata = createEntityMetadataMap(JobLog, JobLogError);
